const FETCH_EPISODE = 'episodeDetail/FETCH_EPISODE';

const SAVE_EPISODE_DATA = 'episodeDetail/SAVE_EPISODE_DATA';

const LIKE_COMMENT = 'episodeDetail/LIKE_COMMENT';

const FETCH_USER_OTHER_STORIES = 'episodeDetail/FETCH_USER_OTHER_STORIES';

const RESET_RECOMMENDATIONS = 'episodeDetail/RESET_RECOMMENDATIONS';

const FETCH_STORY_RECOMMENDATIONS = 'episodeDetail/FETCH_STORY_RECOMMENDATIONS';

const SAVE_TAP_COUNT = 'episodeDetail/SAVE_TAP_COUNT';

const PURCHASE_EPISODE = 'episodeDetail/PURCHASE_EPISODE';

const READ_EPISODE = 'episodeDetail/READ_EPISODE';

const FETCH_PAID_CHOICES = 'episodeDetail/FETCH_PAID_CHOICES';
const PURCHASE_CHOICE = 'episodeDetail/PURCHASE_CHOICE';

const SAVE_WATCH_LATER = 'episodeDetail/SAVE_WATCH_LATER';
const DELETE_WATCH_LATER = 'episodeDetail/DELETE_WATCH_LATER';

const FETCH_EPISODE_DONATION_RANKINGS =
  'episodeDetail/FETCH_EPISODE_DONATION_RANKINGS';

export default {
  FETCH_EPISODE,
  SAVE_EPISODE_DATA,
  LIKE_COMMENT,
  FETCH_USER_OTHER_STORIES,
  RESET_RECOMMENDATIONS,
  FETCH_STORY_RECOMMENDATIONS,
  SAVE_TAP_COUNT,
  PURCHASE_EPISODE,
  READ_EPISODE,
  FETCH_PAID_CHOICES,
  PURCHASE_CHOICE,
  SAVE_WATCH_LATER,
  DELETE_WATCH_LATER,
  FETCH_EPISODE_DONATION_RANKINGS,
};



// WEBPACK FOOTER //
// ./src/app/redux/front/episodeDetail/types.js